import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { FormBox } from 'components';
import { Grid } from 'semantic-ui-react';

import * as cm_action from 'actions/commons';
import * as sik_action from 'actions/sikdae';

const propTypes = {};

const defaultProps = {};

class Search extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sikdaeGroupVal: 0
    };
  }

  componentDidMount() {
    //식대그룹 조회
    this.sikdaeGroup();

    //가맹점 조회
    this.storeSearch();

    //부서 조회
    this.divisionSearch();

    //식대 상태 조회
    this.sikdaeStatus();
  }

  //식대 그룹 조회
  sikdaeGroup = async () => {
    const { cmAPI } = this.props;

    try {
      await cmAPI.sikdaeGroupList();
    } catch (e) {
      console.log('###### sikdaeGroup : ', e);
    } finally {
    }
  };

  //식대그룹 search
  sikdaeGroupSearch = async () => {
    const { groupIdx } = this.props;

    if (groupIdx.value !== 0) {
      const { cmAPI } = this.props;

      try {
        //식대정책 조회
        await cmAPI.sikdaePolicyList(groupIdx.value);
      } catch (e) {
        console.log('##### sikdaePolicyList error : ', e);
      }
    } else {
    }

    this.setState({ sikdaeGroupVal: groupIdx.value });
  };

  //가맹점
  storeSearch = async () => {
    try {
      const { cmAPI } = this.props;
      const params = '/?';

      await cmAPI.storeList(params);
    } catch (e) {
      console.log('##### storeSearch : ', e);
    }
  };

  //부서 search
  divisionSearch = async () => {
    try {
      const { cmAPI } = this.props;

      await cmAPI.divisionList();
    } catch (e) {
      console.log('###### divisionSearch : ', e);
    } finally {
    }
  };

  //식대 상태 정보
  sikdaeStatus = () => {
    const { sikAPI } = this.props;
    try {
      sikAPI.sikdaeStatus();
    } catch (e) {
      console.log('##### sikdaeStatus : ', e);
    }
  };

  render() {
    const { sikdaeGroupVal } = this.state,
      { sikdaeGroup, sikdaePolicy, companyStore, division, policyIdx, sikStatus } = this.props,
      FormBoxObj = {
        companyStore: companyStore,
        sikdaeGroupVal: sikdaeGroupVal,
        sikdaeGroup: sikdaeGroup,
        sikdaePolicy: sikdaePolicy,
        division: division,
        sikdaeGroupSearch: this.sikdaeGroupSearch,
        sikStatus: sikStatus
      };

    return (
      <main>
        <div className="search-box">
          <FormBox FormBoxObj={FormBoxObj} />
        </div>
      </main>
    );
  }
}

Search.propTypes = propTypes;
Search.defaultProps = defaultProps;

Search = connect(
  (state) => ({
    sikdaeGroup: state.commons.sikdaeGroup,
    sikdaePolicy: state.commons.sikdaePolicy,
    sikStatus: state.sikdae.sikdaeStatus,
    companyStore: state.commons.companyStore,
    division: state.commons.division,
    divisionDepth1: state.commons.divisionDepth1,
    groupIdx: state.commons.group,
    policyIdx: state.commons.policy,
    statusStr: state.commons.statusStr,
    dateType: state.commons.dateType
  }),
  (dispatch) => ({
    cmAPI: bindActionCreators(
      {
        sikdaeGroupList: cm_action.SikdaeGroupList,
        sikdaePolicyList: cm_action.SikdaePolicyList,
        storeList: cm_action.StoreList,
        divisionList: cm_action.DivisionList
      },
      dispatch
    ),

    commonsFn: bindActionCreators(
      {
        divisionChange: cm_action.ChangeDivision
      },
      dispatch
    ),

    sikAPI: bindActionCreators(
      {
        sikdaeStatus: sik_action.SikdaeStatusList
      },
      dispatch
    )
  })
)(Search);

export default Search;
